import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import ReactModal from 'react-modal';
import { useRecoilValue } from 'recoil';
import { chatModalState } from '@/state/session';
import { CloseChat } from './ChatModalContent/CloseChat/CloseChat';
import { Resolved } from './ChatModalContent/Resolved/Resolved';
import { Survey } from './ChatModalContent/Survey/Survey';
import styles from './ChatModal.module.scss';
import './ChatModalPortal.scss';
export const ChatModal = () => {
    const chatModal = useRecoilValue(chatModalState);
    const showChatForm = chatModal &&
        [
            "closing" /* ChatModalStatus.Closing */,
            "inactivity" /* ChatModalStatus.Inactivity */,
            "expired" /* ChatModalStatus.Expired */,
        ].includes(chatModal);
    const showSurvey = chatModal === null || chatModal === void 0 ? void 0 : chatModal.startsWith("survey" /* ChatModalStatus.Survey */);
    const showResolved = chatModal && chatModal === "closed" /* ChatModalStatus.Resolved */;
    return (_jsxs(ReactModal, { id: "modal", isOpen: chatModal !== null, contentLabel: "webview", portalClassName: cn('inline-modal', styles.portal), className: cn(styles.modalContent, styles[chatModal !== null && chatModal !== void 0 ? chatModal : '']), overlayClassName: styles.modalOverlay, ariaHideApp: false, closeTimeoutMS: 300, parentSelector: () => document.querySelector('.chatContainer'), children: [showChatForm && _jsx(CloseChat, { type: chatModal }), showSurvey && _jsx(Survey, {}), showResolved && _jsx(Resolved, {})] }));
};
